import React, { Component } from 'react';
import '../../css//agenttoolbar/agentmenu.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import SignalRService from '../../controllers/SignalRService';
import Group from './group';
import { notify } from '../utils/utils';

class AgentGroups extends Component {

    constructor(props) {
        super(props);
        this.state = {
            groups: [],
            totalCallsInQueue: 0,
            colors: ["danger", "success", "primary", "info", "warning"],
            maxWaitingTime: 0,
            showAll: false,
            height: 105
        }
        this.lastUpdateTime = null;
        this.setGroups = this.setGroups.bind(this);
        this.toggleGroups = this.toggleGroups.bind(this);

    }

    componentDidMount() {
        SignalRService.registerQueuesEvent(this.setGroups);
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.functions?.queueNotificationsTimer > 0) {

            const now = Date.now();
            let elapsed = this.props.functions?.queueNotificationsTimer;

            if (this.lastUpdateTime)
                elapsed = (now - this.lastUpdateTime) / 1000;

            if (elapsed >= this.props.functions?.queueNotificationsTimer) {

                let notificationBody = "";
                this.state.groups.forEach((element, index) => {
                    if (element.totalCallsInQueue > 0 && element.disabled === false)
                        notificationBody += (`${element.queueName}: ${element.totalCallsInQueue}\r\n`);
                });

                if (notificationBody !== "") {
                    this.lastUpdateTime = now;
                    notify(`Fidelity Agent: ${this.props.t("queuedcalls")}`, notificationBody, `${window.location.origin}${window.location.pathname}/favicon.ico`, "queue");
                    console.log(`Time since last update: ${elapsed}s`);
                }
            }

        }
    }

    setGroups(groups) {

        var groupsArr = Object.values(groups),
            total = 0,
            max = Math.max(...groupsArr.map(o => o.maxWaitingTime));

        groupsArr.forEach((element, index) => {
            total += element.totalCallsInQueue;
        });

        groupsArr.sort(function (a, b) {
            return a.queueName.toLowerCase().localeCompare(b.queueName.toLowerCase());
        });

        //groupsArr = groupsArr.slice(0, 5);

        var global = [{
            queueName: "GLOBAL",
            totalCallsInQueue: total,
            maxWaitingTime: max

        }];

        if (total === 0)
            this.lastUpdateTime = null;

        this.setState({
            groups: global.concat(groupsArr),
        });



    };

    toggleGroups = e => {
        this.setState({
            showAll: !this.state.showAll,
            height: !this.state.showAll ? 500 : 115
        });
    }
    render() {
        var groupsElements = [];
        if (this.state.groups) {

            let i = 0;
            groupsElements = this.state.groups.map((g) => {
                if (i > 4)
                    i = 1;
                let color = this.state.colors[i],
                    elem = <Group key={g.queueName} group={g.queueName} color={color} totalCallsInQueue={g.totalCallsInQueue}
                        maxWaitingTime={g.maxWaitingTime} disabled={g.disabled} userId={this.props.userId} extension={this.props.extension} closed={g.closed}></Group>;
                i += 1;
                return elem;
            });
        }

        return (
            <>
                <div className='groupsrow' style={
                    {
                        height: this.state.height,
                        overflowY: "auto",
                        transition: "all 0.5s",
                        width: "100%",
                        bottom: "15px"

                    }}>
                    {groupsElements}
                </div>
            </>

        );
    }
}
const mapStateToProps = (state) => {
    return {
        name: state.agent.name,
        status: state.agent.status,
        shortExtension: state.agent.shortExtension,
        photo: state.agent.photo,
        initials: state.agent.initials,
        duple: state.agent.duple,
        extension: state.agent.extension,
        userId: state.agent.userId,
        functions: state.agent.functions
    };
};

export default compose(connect(mapStateToProps), withTranslation())(AgentGroups);